/* eslint-disable react/no-array-index-key */
import React from 'react';
import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../../cra/src/styling/breakpointsMinWidth';

const Section = styled.section`
  background: #fcfcfc;
  padding: 60px 20px;
  text-align: center;
`;

const Title = styled.h2`
  align-items: center;
  text-align: center;
  font-size: 28px;
  line-height: 36px;
  font-weight: 400;
  color: #122241;
  margin-bottom: 40px;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 32px;
    line-height: 64px;
    margin-bottom: 44px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    margin-bottom: 56px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 36px;
    line-height: 64px;
    margin-bottom: 83px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 20px;
  row-gap: 30px;
  justify-items: center;
  max-width: 1200px;
  margin: 0 auto;

  @media ${breakpointsMinWidth.tabletSm} {
    column-gap: 16px;
    row-gap: 36px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    column-gap: 20px;
    row-gap: 44px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    column-gap: 22px;
    row-gap: 54px;
  }
`;

const Card = styled.div`
  max-width: 360px;
  text-align: center;
`;

const IconWrapper = styled.div`
  margin-bottom: 28px;

  svg {
    width: 32px;
    height: 32px;
  }

  @media ${breakpointsMinWidth.tabletSm} {
    margin-bottom: 36px;
    svg {
      width: 36px;
      height: 36px;
    }
  }
  @media ${breakpointsMinWidth.tabletLg} {
    margin-bottom: 44px;
    svg {
      width: 48px;
      height: 48px;
    }
  }
  @media ${breakpointsMinWidth.desktopMd} {
    margin-bottom: 48px;
    svg {
      width: 64px;
      height: 64px;
    }
  }
`;

const CardTitle = styled.h4`
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  color: #222222;
  margin-bottom: 10px;

  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 10px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 12px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 16px;
  }
`;

const Description = styled.p`
  font-size: 14px;
  color: #222222;
  font-weight: 300;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 14px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    font-size: 16px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    font-size: 18px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 20px;
  }
`;

export const PlaceholderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_5732_845)">
      <path
        opacity="0.4"
        d="M13.391 27.9235L14.3643 19.1246C15.3586 10.135 22.9556 3.33203 32 3.33203C41.0444 3.33203 48.6414 10.135 49.6357 19.1246L50.609 27.9235C50.7165 28.8953 51.23 29.7762 52.0226 30.3486L52.713 30.8473C56.0332 33.245 58 37.0914 58 41.1868C58 47.5263 52.8609 52.6654 46.5215 52.6654H17.4785C11.1391 52.6654 6 47.5263 6 41.1868C6 37.0914 7.96675 33.245 11.287 30.8473L11.9774 30.3486C12.77 29.7762 13.2835 28.8953 13.391 27.9235Z"
        fill="#2364EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3333 48.668C26.4378 48.668 27.3333 49.5634 27.3333 50.668V52.0013C27.3333 54.5786 29.4226 56.668 31.9999 56.668C34.5772 56.668 36.6666 54.5786 36.6666 52.0013V50.668C36.6666 49.5634 37.562 48.668 38.6666 48.668C39.7712 48.668 40.6666 49.5634 40.6666 50.668V52.0013C40.6666 56.7878 36.7864 60.668 31.9999 60.668C27.2135 60.668 23.3333 56.7878 23.3333 52.0013V50.668C23.3333 49.5634 24.2287 48.668 25.3333 48.668Z"
        fill="#2364EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5732_845">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const WhyWisedocFeatures = ({ data }) => {
  const { items, title } = data;
  return (
    <Section>
      <Title>{title}</Title>
      <Grid>
        {items.map((item, idx) => (
          <Card key={idx}>
            <IconWrapper>{item.icon || <PlaceholderIcon />}</IconWrapper>
            <CardTitle>{item.title}</CardTitle>
            <Description>{item.description}</Description>
          </Card>
        ))}
      </Grid>
    </Section>
  );
};

export default WhyWisedocFeatures;
